import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { UIRouter, UIView, pushStateLocationPlugin } from "@uirouter/react";

import configureStore from "./store";
import appStates from "./appStates";

const reduxStore = configureStore();

let uiRouterConfigFn = function(router) {
    // If no URL matches, and we don't already have a current state,
    // then go to the `users` state by default. This function is
    // intended to handle the case where a saved bookmark targets some
    // other portlet on the page with a hashed URL, as well as the
    // default state ('')
    //
    // In that initial loading case, we want this portlet to go to its home state
    // but in subsequent cases where this portlet has moved to an active state we
    // want it to stay where it is in terms of state upon receipt of an unknown url.

    router.urlService.rules.otherwise(function(_router, _url) {
        const currentState = router.stateService.current.name;
        if (!currentState) {
            router.stateService.go("home", null, { location: false });
        }
        return;
    });
};

ReactDOM.render(
    <ReduxProvider store={reduxStore}>
        <UIRouter
            config={uiRouterConfigFn}
            plugins={[pushStateLocationPlugin]}
            states={appStates}
        >
            <UIView />
        </UIRouter>
    </ReduxProvider>,
    document.getElementById("mueller-location-view-portlet")
);



// WEBPACK FOOTER //
// ./App.jsx